import { Temporal } from '@js-temporal/polyfill';
import { CoordinatorService } from './coordinator.service';
import { ScriptComment } from './script-comment';

export class Comment {
    id: string;
    originId: string;
    ownerId: string;
    autouserId?: string;
    date: Temporal.Instant;
    private _text = '';

    constructor(
        private coords: CoordinatorService,
        params: any,
    ) {
        this.id = params['id'] || this.coords.uniqueId();
        this.originId = params['originId'];
        this.ownerId = params['ownerId'];
        this.autouserId = params['autouserId'];
        let dt = params['date'];
        if (dt) {
            if (typeof dt == 'string') {
                try {
                    dt = Temporal.Instant.from(dt);
                } catch (e) {
                    dt = Temporal.Now.instant();
                }
            }
        } else dt = Temporal.Now.instant();
        this.date = dt;
        this._text = params['text'] || '';
    }

    get isCurrentUser() {
        return this.ownerId == this.coords.user$.currentId;
    }

    get userTitle() {
        if (this.isCurrentUser) return this.coords.text('me');
        let t = this.coords.user$.get(this.ownerId)?.name;

        if (!t && this.autouserId) {
            const au = this.coords.autouser$.get(this.autouserId);
            t = au?.name;
        }

        return t || this.coords.text('unknown');
    }

    get isEmpty() {
        return !this._text;
    }

    public get text(): string {
        return this._text || '';
    }
    public set text(value: string) {
        const txt = value.trim();
        if (txt) {
            this._text = txt;
            this.date = Temporal.Now.instant();
        } else this.delete();
        this.coords.comment$.markForManifestStore();
        this.coords.display$.markForCheck();
    }

    delete() {
        this.coords.comment$.delete(this);
    }

    save() {
        const dct: any = {
            id: this.id,
            originId: this.originId,
            date: this.date.toString(),
            text: this.text,
        };
        // if (this.autouserId) dct.autouserId = this.autouserId;
        return dct;
    }

    get scriptClass() {
        return new ScriptComment(this.coords, this);
    }
}
